import { IconButton, Modal, Stack, Typography, Button } from "@mui/material";
import { ContentModal } from "../../Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom";

export default function ModalRedirect({ open, onClose }) {
  const history = useHistory();

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus={true}>
      <ContentModal
        minWidth={"883px"}
        style={{ width: "auto" }}
        borderRadius={"16px"}
      >
        <Stack p={"32px"}>
          <Stack
            direction={"row"}
            justifyContent={"flex-end"}
            alignItems={"center"}
            mb={"32px"}
          >
            <IconButton onClick={onClose}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          </Stack>
          <Typography
            fontSize={"36px"}
            fontWeight={800}
            color={"#03A9F5"}
            mb={"24px"}
          >
            Ops
          </Typography>
          <Typography fontSize={"24px"} fontWeight={500} color={"#053462"}>
            Para visualizar mais detalhes desta fatura, entre em contato com a
            nossa central de atendimento.
          </Typography>
          <Stack alignItems={"flex-end"} mt={"32px"}>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                height: "55px",
                color: "#fff",
                width: "40%",
              }}
              onClick={() => history.push("/help")}
            >
              Fale conosco
            </Button>
          </Stack>
        </Stack>
      </ContentModal>
    </Modal>
  );
}
